import { SeeMoreCard, WhiteBox } from "@foodpilot/foods";
import { Grid2, Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { QuestionnaireOverview, ScoreOverview } from "src/api/client-api/company/overview/useOrganizationOverview";
import { ScoresBodyHeader } from "./ScoresBodyHeader";
import { ScoresBodyOverview } from "./ScoresBodyOverview";
import { useMemo } from "react";

// TODO: To remove when we will have an endpoint that fetches the number of validated regulation scores from the post scores
type ScoresOverviewProps = {
    scoresOverview: ScoreOverview[];
    ssqs: QuestionnaireOverview[];
};
export const ScoresOverview = (props: ScoresOverviewProps) => {
    const theme = useTheme();
    const { t } = useTranslation();

    const { scoresOverview, ssqs } = props;

    const previewItems = useMemo(() => scoresOverview.slice(0, 3), [scoresOverview]);
    const seeMoreItems = useMemo(() => scoresOverview.slice(3), [scoresOverview]);

    const ssqsToPost = ssqs.reduce(
        (acc, value) => {
            const doesPostExist = value.post !== undefined || value.post !== null;
            acc[value.id] = doesPostExist;
            return acc;
        },
        {} as Record<number, boolean>,
    );

    return (
        <WhiteBox>
            <SeeMoreCard
                seeMoreText={t("components.see_more.scores", "See more scores")}
                seeLessText={t("components.see_less.scores", "See less scores")}
                hidden={
                    seeMoreItems.length > 0 ?
                        <Grid2 container spacing={theme.spacing(1)} marginTop={theme.spacing(2)}>
                            {seeMoreItems.map((item: ScoreOverview) => {
                                const doesPostExist = ssqsToPost[item.ssq.id];
                                return (
                                    <ScoresBodyOverview
                                        key={`${item.id}_${item.ssq.id}`}
                                        scoreOverview={item}
                                        doesPostExist={doesPostExist}
                                    />
                                );
                            })}
                        </Grid2>
                    :   undefined
                }
                defaultVisible={false}
            >
                <Stack gap={theme.spacing(2)}>
                    <ScoresBodyHeader scoresCount={scoresOverview.length} />
                    <Grid2 container spacing={theme.spacing(1)}>
                        {previewItems.map((item: ScoreOverview) => {
                            const doesPostExist = ssqsToPost[item.ssq.id];
                            return (
                                <ScoresBodyOverview
                                    key={`${item.id}_${item.ssq.id}`}
                                    scoreOverview={item}
                                    doesPostExist={doesPostExist}
                                />
                            );
                        })}
                    </Grid2>
                </Stack>
            </SeeMoreCard>
        </WhiteBox>
    );
};
